import {Action, Dispatch} from 'redux';
import {ADMIN_EXCHANGES} from '../../../@crema/services/ApiConfig';
import {showError} from '../Common';
import {ApiActionCall, ApiActionTypes} from '../Api';
import {
  FETCH_OPEN_ORDERS,
  FETCH_OPEN_ORDERS_SUCCESS,
  FETCH_OPEN_ORDERS_ERROR,
  OpenOrdersActions,
} from '../../../types/actions/Exchanges/OpenOrders.actions';
import {IOpenOrders} from '../../../types/models/OpenOrders';
import {logger} from '../../../shared/logger';

export const fetchOpenOrders = (exchange: string) => async (
  dispatch: Dispatch<ApiActionCall | OpenOrdersActions>,
) => {
  dispatch({type: FETCH_OPEN_ORDERS});

  const onSuccess = (payload: IOpenOrders) => ({
    type: FETCH_OPEN_ORDERS_SUCCESS,
    payload,
  });
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    logger.error(message);
    dispatch({type: FETCH_OPEN_ORDERS_ERROR});
    dispatch(showError('Failed to fetch open orders.'));
  };
  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: ADMIN_EXCHANGES + exchange + '/open_orders',
      method: 'GET',
      label: 'Fetch open orders',
      onSuccess,
      onFailure,
    },
  });
};
